module.exports = __webpack_public_path__ + "static/media/notification_guidance_1.0997ed2b.jpg";